<div class="flex ">
  <div class="hidden lg:flex flex-col gap-2 p-12">

    <div class="whitespace-nowrap text-xl font-normal">
      {{'profile.yourAccount' | transloco}}
    </div>
    @for (item of items(); track item.url) {
      @if (!item.hidden) {
        <div class="whitespace-nowrap font-light ">
          <a [routerLink]="item.url" class="cursor-pointer py-2" routerLinkActive="text-blue-400">
            {{ 'profile.' + item.label | transloco }}
          </a>
        </div>
      }
    }

  </div>
  <div class="flex-1 min-h-0 ">
    <router-outlet></router-outlet>
  </div>
</div>
